// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"784":"1d0367e8290fe904","952":"521368c891321fd3"}[chunkId] + ".js";
};